import { PermissionEnum } from "../enums/permissions.enum";

export const noninclusiveProjectModulePermissions = [
  PermissionEnum.READ_ROLES,
  PermissionEnum.READ_ARTICLES,
  PermissionEnum.READ_PROJECTS,
  PermissionEnum.READ_JOB_OFFER,
  PermissionEnum.READ_CLIENTS,
  PermissionEnum.READ_PERMISSIONS,
  PermissionEnum.READ_BILLS,
  PermissionEnum.READ_CALENDAR,
];
